import http from '@/http'

const PATH = '/tools/bespokes'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listBespokes (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {BespokeQuery} data
     * @returns {Promise<void>}
     */
    async showBespoke (data) {
        try {
            const response = await http.get(`${PATH}/${data.id}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {BespokeInventoryItem} data
     * @returns {Promise<void>}
     */
    async updateBespoke (data) {
        try {
            const response = await http.put(`${PATH}/${data.id}`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {BespokeItem} data
     * @returns {Promise<void>}
     */
    async removeBespoke (data) {
        try {
            const response = await http.delete(`${PATH}/${data.id}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
